import _ from "lodash";
import { createSelector } from "reselect";
import { selectSindromeAnalisis } from "../sindromeAnalisis/selectors";

export const selectSindromesJerarquizados = createSelector(
  [(state) => state.sindromes, (state) => state.holonmed.sintomasAcupuntura],
  (sindromes, sintomasAcupuntura) => {
    const sintomasAcupunturajerarquizados = sintomasAcupuntura
      .filter((element) => {
        return element.jerarquizado;
      })
      .map((element) => element.codSintoma);

    return sindromes.filter((element) => {
      const codigosSintomasAcupuntura = element.sintomas.map(
        (element) => element.codSintoma,
      );
      return (
        sintomasAcupunturajerarquizados.length ===
        _.intersection(
          codigosSintomasAcupuntura,
          sintomasAcupunturajerarquizados,
        ).length
      );
    });
  },
);

export const selectSindromesAnalisis = createSelector(
  [selectSindromesJerarquizados, selectSindromeAnalisis],
  (sindromesJerarquizados, sindromesAnalisis) =>
    sindromesJerarquizados.filter((element) =>
      sindromesAnalisis.includes(element.codSindrome),
    ),
);
